import { RemoteParticipant } from "twilio-video";

import React, { createContext } from "react";

import { useSpeakerViewParticipants } from "hooks/liveMeeting/useSpeakerViewParticipants";

export type IParticipantContext = {
  speakerViewParticipants: RemoteParticipant[];
};

type Props = {
  children: React.ReactNode;
};

export const ParticipantContext = createContext<IParticipantContext>(null!);

export const ParticipantProvider: React.FC<Props> = ({ children }) => {
  const speakerViewParticipants = useSpeakerViewParticipants();

  return (
    <ParticipantContext.Provider
      value={{
        speakerViewParticipants,
      }}
    >
      {children}
    </ParticipantContext.Provider>
  );
};
